import colors from '@honeybook/hbui/dist/styles/colors';
import { observable } from 'mobx';
import {
    IClientMinimalData,
    ICompanyBrandingData,
    IUserBrandingData
} from '~/components/ClientExperience/GiftCard/types/client-exprience.types';
import {
    IFlowMinimalResponse,
    IMinimalFlowExpiration
} from '~/types/server.types';
import { IFlowTheme } from '~/types/model.types';

export class CXMinimalFlow {
    title: string;
    _theme: IFlowTheme;
    branding_data: ICompanyBrandingData;
    owner: IUserBrandingData;
    @observable client: IClientMinimalData;
    expiration: IMinimalFlowExpiration;
    @observable require_authentication: boolean;
    @observable card_on_file_enabled: boolean;
    improved_smaf_auth_on: boolean;
    is_bookable: boolean;
    is_powered_by_hb: boolean;
    is_client_portal_exposed: boolean;
    client_facing_host: string;

    constructor(minimalFlowResponse: IFlowMinimalResponse) {
        const { theme, ...rest } = minimalFlowResponse;
        Object.assign(this, rest);
        this._theme = theme;
    }

    get theme() {
        return {
            ...this._theme,
            styles: {
                ...this._theme.styles,
                accent_color:
                    this._theme.styles.accent_color ||
                    this.branding_data.brand_color ||
                    colors.defaultBrandColor
            }
        };
    }
}
